import { render, staticRenderFns } from "./archiveUpIcon.vue?vue&type=template&id=f2237aee&scoped=true"
import script from "./archiveUpIcon.vue?vue&type=script&lang=js"
export * from "./archiveUpIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2237aee",
  null
  
)

export default component.exports